import { hooks } from "./hookactions"
export let QUTBPFilter = { hooks }
